import { Button } from "antd";
import { useEffect, useState } from "react";
import WithPermission from "../components/misc/WithPermission";
import ManageUser from "../components/users/ManageUser";
import UserList from "../components/users/UserList";
import { User } from "../entities/interfaces/users";
import UserService from "../services/users.service";

const Users = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [manageUserModal, setManageUserModal] = useState(false);
  const [selected, setSelected] = useState<User | undefined>();

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    const res = await UserService.list();
    if (!res?.success) return;
    setUsers(res.data);
  };

  const openManageUserModal = () => {
    setManageUserModal(true);
  };

  const closeManageUserModal = () => {
    if (selected) {
      setSelected(undefined);
    }
    setManageUserModal(false);
  };

  return (
    <div>
      <div className="flex justify-between">
        <div className="mb-5">
          <h1 className="text-xl font-bold">Users</h1>
          <p>Manage your organisation users</p>
        </div>
        <WithPermission permission="create:users">
          <Button type="primary" onClick={openManageUserModal}>
            Create User
          </Button>
        </WithPermission>

        <ManageUser
          open={manageUserModal}
          onChange={getUsers}
          onClose={closeManageUserModal}
          selected={selected}
        />
      </div>
      <UserList
        users={users}
        onSelect={(data) => {
          openManageUserModal();
          setSelected(data);
        }}
      />
    </div>
  );
};

export default Users;
